import React from 'react'
import { PageHeader } from "antd";
import ProgramTransferList from '../../components/enrollment/ProgrammeTransferList';
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'

const TransferProgramme = () => {
  return (
    <div className="inside-main-content">
    <AdminBreadCrumb />

    <div className="box-style">
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Programme Transfer List"
        subTitle=""
        extra={[]}
      ></PageHeader>

      <ProgramTransferList />

    </div>
  </div>
  )
}

export default TransferProgramme